import { HTMLProps } from 'react';
import { cx } from '@emotion/css';
import { useTranslation } from 'next-i18next';

import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';

export const QuickActionLink = ({
  icon,
  label,
  id,
  className = 'h-8 w-8',
  ...props
}: HTMLProps<HTMLAnchorElement> & { icon: string; label?: string }) => {
  const { t } = useTranslation('shared');
  return (
    <div className="group/action relative" data-testid={id} onClick={(e) => e.stopPropagation()}>
      <a
        className="rounded-full !outline-offset-[3px] focus:outline-primary-black"
        {...props}
        aria-label={props['aria-label'] ?? props.target === '_blank' ? `${label} (${t('shared_a11y_hint_opensInNewTab')})` : label}
      >
        <PhoenixIcon className={cx(className, 'hover:text-secondary-dark')} icon={getDesignSystemIcon(icon)} />
      </a>
      {label && (
        <span className="group/label absolute -top-2 left-1/2 hidden -translate-x-1/2 -translate-y-full animate-fade-in whitespace-nowrap bg-secondary-dark px-2 py-1 text-primary-white stihl-text-body-sm-reg group-hover/action:block">
          {label}
        </span>
      )}
    </div>
  );
};
